import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-benefit-configuration-dashboard",
  templateUrl: "./benefit-configuration-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BenefitConfigurationDashboardComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.BenefitConfigurationDashboard;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}

